import React from "react";
import './webdevservices.css';
import PageTemplate from "../../templates/page-template/PageTemplate";
import WebDevContent from "../../organisms/WebDevContent/WebDevContent";

const WebDevServices: React.FC = () => {
    return (
        <PageTemplate children={<WebDevContent/>}></PageTemplate>
    );
};

export default WebDevServices;